export default __webpack_public_path__ + "static/media/liderança.dcbec0e0.png";